export default __webpack_public_path__ + "static/media/bracelet.f28718b1.png";